<template>
    <div class="block-promo" id="block-promo">
        <div class="main-wrap">
            <div class="block-promo__content">
                <p class="block-promo__title">0-3</p>
                <p class="block-promo__text">
                    Первая ночь дома, первое «агу», первая улыбка и&nbsp;первый шаг. Первый транспорт, сотни бессонных ночей, сказок на&nbsp;ночь и&nbsp;игрушек вокруг.
                </p>
                <BlockParallax class="block-promo__icon block-promo--pram-white" speed="2">
                    <img src="@/assets/images/icons/pram-white.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--bottle-white" speed="4" direction="left">
                    <img src="@/assets/images/icons/bottle-white.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--bottle-blue block-promo--icon-desktop" speed="8">
                    <img src="@/assets/images/icons/bottle-blue.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--bottle-pink" speed="6" direction="left">
                    <img src="@/assets/images/icons/bottle-pink.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--toy-blue" speed="8">
                    <img src="@/assets/images/icons/toy-blue.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--toy-white block-promo--icon-desktop " speed="8" direction="left">
                    <img src="@/assets/images/icons/toy-white.png">
                </BlockParallax>
                <BlockParallax class="block-promo__icon block-promo--toy-pink block-promo--icon-desktop " speed="8">
                    <img src="@/assets/images/icons/toy-pink.png">
                </BlockParallax>
                <icon-arrow class="block-promo__arrow" v-scroll-to="'#block-info'" />
            </div>
        </div>
        <BlockParallax class="block-promo__icon block-promo--icon-pram-animate" transform="animate1" speed="4">
            <BlockPram />
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--icon-pram-animate-two" transform="animate2" speed="5">
            <BlockPram icon-color="blue" />
        </BlockParallax>
    </div>
</template>

<script>
import BlockPram from '@/components/blocks/pram'
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax,
        BlockPram
    }
}
</script>


<style scoped lang="stylus">
    .block-promo {
        position: relative
        background-color $color-blue
        overflow hidden
        background-image url('~@/assets/images/icons/line-pink-1.png') ,
        url('~@/assets/images/icons/line-blue-1.png')
        background-repeat no-repeat
        background-position bottom -31px left,
        right -14.7rem top
        background-size 32rem
        &:before {
           +layout-l-and-up() {
               content ''
               position absolute
               width 30rem
               height 100%
               left 12.9rem
               top 0
               background no-repeat center / cover url('~@/assets/images/icons/line-white-1.png')
           }
        }
        +layout-md-and-up() {
            position: relative
            background-image url('~@/assets/images/icons/line-pink-1.png'), url('~@/assets/images/icons/line-blue-1.png'), url('~@/assets/images/icons/line-white-2.png')
            background-position bottom -1.1rem left, right -3.7rem top -2rem, right 1.3rem bottom 1.1rem
            background-size 51.8rem
        }

        &__content {
            position relative
            padding-bottom 1.6rem
            +layout-md-and-up() {
                display flex
                flex-direction column
                align-items center
                padding-bottom: 5.6rem

            }
        }

        &__title {
            font-size 5.6rem
            color #FFFFFF
            font-weight 900
            letter-spacing 0.61px
            margin 2.7rem 0 0
            padding 0 0 0 5rem

            +layout-sm-and-up() {
                text-align center
                padding 0
            }
            +layout-md-and-up() {
                font-size 8rem
                letter-spacing 0.87px
                margin 12rem 0 0
                padding 0
            }
        }

        &__text {
            box-sizing border-box
            margin: 0
            padding 2rem 2rem 14rem 5rem
            font-size 1.5rem
            line-height 1.47
            color $color-text

            +layout-sm-and-up() {
                text-align center
                font-size 1.8rem
                line-height 2.8rem
                letter-spacing 0.19px
            }
            +layout-md-and-up() {
                width 100%
                max-width 63rem
                padding-bottom: 0
                padding-top 3.9rem

            }
        }

        &__icon {
            position absolute
            max-width 100%
        }

        &--desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &--pram-white {
            width 7.3rem
            height 7.3rem
            left 1.5rem
            bottom 5.5rem
            +layout-md-and-up() {
                display none
            }
        }

        &--icon-pram-animate {
            display none
            +layout-md-and-up() {
                display flex
                left: 1.9rem;
                bottom: 11.9rem;
                transform rotate(4deg)
            }
        }
        &--icon-pram-animate-two {
            display none
            +layout-md-and-up() {
                display flex
                left auto
                right 24.5rem
                bottom 6.5rem
                transform rotate(-26deg)
                width 11rem
            }
        }

        &--bottle-white {
            width 7.3rem
            height 7.3rem
            left -3.5rem
            bottom 13.5rem
            +layout-md-and-up() {
                width 5.3rem
                height auto
                left auto
                right -20.3rem
                bottom 22.5rem
            }
        }

        &--bottle-pink {
            width 7.3rem
            height 7.3rem
            top 1rem
            right -4rem
            transform rotate(221.3deg)
            +layout-md-and-up() {
                width 11.3rem
                height auto
                top 11rem;
                right auto
                left -23rem
                -webkit-transform rotate(221.3deg)
                transform rotate(0)
            }
        }

        &--bottle-blue {
            +layout-md-and-up() {
                width 6rem
                height auto
                top 4rem
                right auto
                left 18rem
                transform rotate(1deg)
            }
        }

        &--toy-blue {
            width 7.3rem
            height 7.3rem
            bottom 3rem
            right 3.5rem
            transform: rotate(68deg)
            +layout-md-and-up() {
                width 11.3rem
                height auto
                bottom auto
                right -10.5rem
                -webkit-transform: rotate(68deg)
                transform rotate(-16deg)
                top 3rem
            }
        }

        &--toy-white {
            +layout-md-and-up() {
                width 9.3rem
                height auto
                bottom 4rem
                right 54.5rem
                -webkit-transform rotate(68deg)
                transform rotate(-54deg)
            }
        }

        &--toy-pink {
            +layout-md-and-up() {
                width: 12.3rem
                height auto
                top 1rem
                right 18.5rem
                transform rotate(6deg)
            }
        }
        &__arrow {
            width 2rem
            position absolute
            right 0.6rem
            bottom 2rem
            animation translate 1.5s linear infinite forwards

            +layout-md-and-up() {
                position: static
                padding-top: 0
                margin-top: 2rem
                padding-bottom 8.5rem
                cursor pointer

                &:hover {
                    fill: $color-blue
                    cursor pointer
                    animation-play-state paused
                    opacity:0.7
                }
            }
        }
    }

</style>
